export default {
  modulesValue: [],
  error: false,
  errorMessage: '',
  complete: false,
  completeMessage: '',
  modulesList: [],
};

